{
  "care.streak.moment.day1": "🌱 Day 1. Your journey begins!",
  "care.streak.moment.day2": "✨ Day 2. Great start!",
  "care.streak.moment.day3": "🔥 Day 3. You're getting into the rhythm!",
  "care.streak.moment.day4": "💧 Day 4. Your Suikamon feels cared for.",
  "care.streak.moment.day5": "🌟 Day 5. Amazing consistency.",
  "care.streak.moment.day6": "💖 Day 6. Your bond is growing stronger!",
  "care.streak.moment.week1": "🏆 Week 1. Seven days of dedication!",
  "care.streak.moment.week2": "⚡ Week 2. Two weeks of pure dedication!",
  "care.streak.moment.week3": "🔥 Week 3. Your Suikamon is proud.",
  "care.streak.moment.master": "👑 Suikamon Master. 30 days strong!",
  "care.streak.losingIn": "⏰ Losing {days} day streak in <timer>{time}</timer>",
  "care.streak.lost": "💔 Your {days} day streak was lost!",
  "care.streak.lostShort": "💔 Streak lost",
  "care.streak.missesYou": "🗨️ Your Suikamon misses you!",
  "care.streak.missesYouShort": "🗨️ Misses you",
  "care.streak.start": "✨ Start a daily care streak",
  "care.streak.startShort": "✨ New streak",
  "care.streak.dayShort": "{emoji} Day {days}",
  "care.streak.unstoppable": "Day {days}: 🚀 Unstoppable dedication!",
  "care.streak.keepGoing": "Day {days}: ✨ Keep it going!",
  "care.streak.badgeTitle": "Care streak bonus",
  "care.panel.loading": "Fetching your pets...",
  "care.panel.loadingDetail": "We're syncing with the Suikamon backend. Hang tight!",
  "care.panel.selectPet": "Select a pet to view details",
  "care.panel.back": "← Back",
  "care.panel.viewOnExplorer": "View {name} on SuiScan explorer",
  "care.panel.openTutorial": "Open tutorial",
  "care.panel.howToPlay": "How to play",
  "care.panel.petAge": "Pet age: {age}",
  "care.panel.totalXp": "Total XP {xp}",
  "care.panel.xpShort": "XP {xp}",
  "care.panel.maxLevel": "Max Level",
  "care.panel.level": "Level {level}",
  "care.stat.health": "Health",
  "care.stat.hunger": "Hunger",
  "care.stat.happiness": "Happiness",
  "care.stat.energy": "Energy",
  "care.stat.discipline": "Discipline",
  "care.poop.cannotClean": "Cannot clean while pet is sleeping",
  "care.poop.clickToClean": "Click to clean (+{amount} cleanliness)",
  "care.go.battleTitle": "Ranked battle",
  "care.go.battle": "Battle",
  "care.go.skillsTitle": "This Suikamon's skills — the four moves it takes into a battle",
  "care.go.skills": "Skills",
  "care.action.addSuikaTitle": "Add Suika to wake up",
  "care.action.suika": "Suika",
  "care.action.feed": "Feed",
  "care.action.snack": "Snack",
  "care.action.clean": "Clean",
  "care.action.play": "Play",
  "care.action.heal": "Heal",
  "care.action.rest": "Rest",
  "care.action.wake": "Wake",
  "care.action.energy": "Energy",
  "care.sell.link": "Sell Suikamon (+{amount} SUIKA)",
  "care.sell.title": "Sell Suikamon",
  "care.sell.description": "Permanently transfer your Suikamon to the reserve in exchange for SUIKA.",
  "care.sell.reward": "+{amount} SUIKA",
  "care.sell.formula": "{base} base + {perLevel} × level {level}",
  "care.sell.explain": "{name} will be transferred to the Suikamon reserve. SUIKA goes to your Trainer balance, which you can transfer to any of your other Suikamons.",
  "care.sell.cannotUndo": "⚠️ This action cannot be undone.",
  "care.sell.selling": "Selling...",
  "care.sell.confirm": "Sell for {amount} SUIKA",
  "care.minigame.skipClean": "Just clean",
  "care.minigame.skipSnack": "Just snack",
  "care.minigame.skipFeed": "Just feed",
  "care.toast.actionFailed": "Action failed",
  "care.toast.failedTryAgain": "{failure}. Please try again.",
  "care.minigame.tier.bronze": "🎮 BRONZE!",
  "care.minigame.tier.silver": "🎮 SILVER!",
  "care.minigame.tier.gold": "🎮 GOLD!",
  "care.minigame.tier.perfect": "🎮 PERFECT!",
  "care.minigame.reward": "{tier} {rewards}",
  "care.minigame.bonusStat.hunger": "+{amount} hunger",
  "care.minigame.bonusStat.happiness": "+{amount} happiness",
  "care.minigame.bonusStat.discipline": "+{amount} discipline",
  "care.minigame.bonusXp": "+{amount} bonus XP",
  "care.minigame.suikaBack": "{amount} Suika back",
  "care.minigame.dailyBonusXp": "+{amount} daily bonus XP",
  "care.toast.feeding": "Feeding",
  "care.toast.snacking": "Giving snack",
  "care.toast.feedFailed": "Feed failed",
  "care.toast.notEnoughEnergyToTrain": "Not enough energy! Need at least {energy} energy to train.",
  "care.toast.training": "Training",
  "care.toast.trainingFailed": "Training failed",
  "care.toast.cleaning": "Cleaning",
  "care.toast.cleaningPoop": "Cleaning poop",
  "care.toast.cleanFailed": "Clean failed",
  "care.toast.refillCooldown": "Energy refill cooldown: {hours, plural, one {# hour} other {# hours}} remaining.",
  "care.toast.refilling": "Refilling energy",
  "care.toast.refillFailed": "Refill failed",
  "care.toast.medicine": "Giving medicine",
  "care.toast.medicineFailed": "Medicine failed",
  "care.rest.needHunger": "Hunger must be at least {min} (currently {hunger})",
  "care.rest.energyTooHigh": "Energy must be {max} or less (currently {energy})",
  "care.rest.sick": "Pet cannot rest while sick",
  "care.rest.alreadyResting": "Pet is already resting",
  "care.rest.cannotRest": "Cannot rest:\n{reasons}",
  "care.toast.startingRest": "Starting rest",
  "care.toast.startRestFailed": "Start rest failed",
  "care.toast.wakingUp": "Waking up",
  "care.toast.stopRestFailed": "Stop rest failed",
  "care.toast.updating": "Updating",
  "care.toast.tickFailed": "Tick failed",
  "care.disabled.egg.feed": "Cannot feed an egg",
  "care.disabled.egg.train": "Cannot train an egg",
  "care.disabled.egg.clean": "Cannot clean an egg",
  "care.disabled.egg.refill": "Cannot refill an egg",
  "care.disabled.egg.medicine": "Cannot give medicine to an egg",
  "care.disabled.egg.rest": "Cannot rest an egg",
  "care.disabled.egg.wake": "Cannot wake an egg",
  "care.disabled.egg.tick": "Cannot update an egg",
  "care.disabled.hibernated": "Pet is hibernated—add Suika to wake it up",
  "care.disabled.feedResting": "Cannot feed while resting",
  "care.disabled.full": "Already full",
  "care.disabled.tooFullForMeal": "Too full for a meal—try a snack instead",
  "care.disabled.trainResting": "Cannot train while resting",
  "care.disabled.trainSick": "Cannot train when sick",
  "care.disabled.trainEnergy": "Need at least {energy} energy",
  "care.disabled.cleanResting": "Cannot clean while resting",
  "care.disabled.alreadyClean": "Already clean",
  "care.disabled.refillResting": "Already regenerating energy while resting",
  "care.disabled.energyNearlyFull": "Energy is nearly full",
  "care.disabled.refillCooldown": "Cooldown: {hours}h remaining",
  "care.disabled.medicineResting": "Cannot give medicine while resting",
  "care.disabled.alreadyResting": "Already resting",
  "care.disabled.energyTooHigh": "Energy too high (must be {max} or less)",
  "care.disabled.notResting": "Not resting",
  "care.tooltip.meal": "Feed Meal: +{hunger} hunger, +{happiness} happiness, +{health} health",
  "care.tooltip.snack": "Feed Snack: +{hunger} hunger, +{happiness} happiness, -{healthLoss} health, -{cleanlinessLoss} cleanliness",
  "care.tooltip.train": "Train with mini-game for bonus XP! (costs {energy} energy, +{happiness} happiness, +{health} health)",
  "care.tooltip.clean": "Clean Suikamon: +{cleanliness} cleanliness, +{happiness} happiness",
  "care.tooltip.refill": "Refill energy to {max} ({hours}h cooldown)",
  "care.tooltip.medicine": "Restore +{health} health, -{happiness} happiness",
  "care.tooltip.rest": "Enter rest mode: reduced decay, energy regeneration (requires energy ≤ {max})",
  "care.tooltip.wake": "Wake up from rest mode",
  "care.tooltip.tick": "Update pet state",
  "care.roster.title": "Your Suikamons",
  "care.roster.groupBySpecies": "Group by species",
  "care.roster.newSuikamon": "New Suikamon",
  "care.roster.browse": "Browse",
  "care.tutorial.welcome.title": "Welcome to Suikamon!",
  "care.tutorial.welcome.text": "Let's learn how to take care of your Suikamon. Each action earns XP and keeps your pet happy. Build daily care streaks to track your consistency!",
  "care.tutorial.welcome.action": "Start Tutorial",
  "care.tutorial.feedMeal.title": "Feed Meal",
  "care.tutorial.feedMeal.text": "Meals restore {feedMealHungerGain} hunger and give +{feedMealHealthGain} health. No mess! Feed when hunger is low (<{hungerXpThresholdFull}) for {xpFeedFull} XP.",
  "care.tutorial.feedMeal.action": "Feed Meal",
  "care.tutorial.feedSnack.title": "Feed Snack",
  "care.tutorial.feedSnack.text": "Snacks give +{feedSnackHappinessGain} happiness but are junk food! They cost less Suika but reduce health and cleanliness. Use sparingly!",
  "care.tutorial.feedSnack.action": "Feed Snack",
  "care.tutorial.clean.title": "Keep Clean",
  "care.tutorial.clean.text": "Cleaning sets cleanliness to 100 and gives +{cleanHealthGain} health. Clean when dirty (<{cleanlinessDirtyThreshold}) for {xpClean} XP. Low cleanliness causes sickness!",
  "care.tutorial.clean.action": "Clean",
  "care.tutorial.train.title": "Play & Train",
  "care.tutorial.train.text": "Training costs {energyCostTrain} energy but builds discipline and happiness. Spin the wheel for 0-100 XP! Can't train when sick or low energy.",
  "care.tutorial.train.action": "Train",
  "care.tutorial.rest.title": "Rest Time",
  "care.tutorial.rest.text": "Resting regenerates +{energyRegenPerTick} energy every 10 min (~20 min full restore) with reduced decay. Auto-wakes when full energy + 8h inactive. Early wake (below {energyEarlyWakePenaltyThreshold} energy) costs -{sleepEarlyWakeHappinessPenalty} happiness.",
  "care.tutorial.rest.action": "Start Rest",
  "care.tutorial.energyRefill.title": "Energy Refill",
  "care.tutorial.energyRefill.text": "Instantly restore energy to 100! Has a 24-hour cooldown. Use when energy is very low and you need to train immediately. No XP but very useful!",
  "care.tutorial.energyRefill.action": "Refill Energy",
  "care.tutorial.medicine.title": "Medicine",
  "care.tutorial.medicine.text": "When your pet gets sick (health <{healthSickThreshold}), use medicine to cure it! Restores +{medicineHealthGain} health and earns {xpHealSickness} XP. Only appears when needed.",
  "care.tutorial.medicine.action": "Give Medicine",
  "care.tutorial.leveling.title": "Earning XP & Levels",
  "care.tutorial.leveling.text": "Every action earns XP! XP fills your level bar. When it's full, a \"Level Up\" button appears. Click it to increase your level. Higher levels unlock evolutions and discovery!",
  "care.tutorial.evolution.title": "Evolution",
  "care.tutorial.evolution.text": "At certain level milestones, your Suikamon can evolve! An \"Evolve\" or \"Hatch\" button appears. Each evolution unlocks stunning new artwork and makes it stronger in battle.",
  "care.tutorial.discovery.title": "Finding New Friends",
  "care.tutorial.discovery.text": "Every {breedingLevelInterval} levels, you earn a discovery token! Use it to find a new Suikamon egg. Your pet's rarity affects the chances of finding rare species. Limited supply per species!",
  "care.tutorial.complete.title": "Ready to Play!",
  "care.tutorial.complete.text": "You've learned everything! Care daily to build streaks, watch your stats, and help your Suikamon grow. Good luck on your adventure!",
  "care.tutorial.complete.action": "Start Playing!",
  "care.tutorial.gotIt": "Got It!",
  "care.stat.cleanliness": "Cleanliness",
  "care.stat.xp": "XP",
  "care.tutorial.stepOf": "Step {step} of {total}",
  "care.tutorial.xpTitle": "Experience Points",
  "care.tutorial.xpProgress": "{xp} / {max} XP",
  "care.tutorial.petStats": "{petName}'s Stats",
  "care.tutorial.statValue": "{value}%",
  "care.tutorial.done": "Done!",
  "care.tutorial.skip": "Skip Tutorial",
  "care.tutorial.completeTitle": "Tutorial Complete!",
  "care.tutorial.completeText": "You've learned all the actions. Now go care for your Suikamon!",
  "care.tutorial.restart": "Restart Tutorial",
  "care.companion.saysHello": "{petName} says hello",
  "care.companion.answerPlaceholder": "Type your answer...",
  "care.companion.answerLabel": "Your answer",
  "care.companion.keepNickname": "Yep! 💛",
  "care.companion.changeNickname": "Change it",
  "care.companion.nicknamePlaceholder": "Type your new name...",
  "care.companion.nicknameLabel": "Your new name",
  "care.companion.ctaDefault": "Let's go",
  "care.companion.opensInNewTab": "{label} (opens in new tab)",
  "care.companion.notYet": "Not yet",
  "care.petDetail.loading": "Loading pet details...",
  "care.petDetail.legacyTitle": "A Legacy Suikamon",
  "care.petDetail.legacyText": "This Suikamon lived before Suikamon 20. Every trainer starts fresh now — with a free starter.",
  "care.petDetail.legacyCta": "Get your free Suikamon",
  "care.petDetail.notFoundTitle": "Pet Not Found",
  "care.petDetail.notFoundText": "Unable to load pet details",
  "care.petDetail.browseAll": "Browse All Pets",
  "care.petDetail.backToRankings": "Back to Rankings",
  "care.petDetail.skills": "Skills",
  "care.petDetail.levelBadge": "LVL {level}",
  "care.petDetail.viewTrainer": "View Trainer",
  "care.petDetail.unknownSpecies": "Unknown Species",
  "care.petDetail.born": "Born",
  "care.petDetail.level": "Level",
  "care.petDetail.evolution": "Evolution",
  "care.petDetail.species": "Species",
  "care.petDetail.rarity": "Rarity",
  "care.petDetail.element": "Element",
  "care.petDetail.number": "Number",
  "care.petDetail.owner": "Owner",
  "care.petDetail.bio": "Bio",
  "care.petDetail.noBio": "No description",
  "care.petDetail.loadingStats": "Loading statistics...",
  "care.wheel.title": "Training Wheel",
  "care.wheel.intro": "Spin the wheel for bonus XP!",
  "care.wheel.introUpgraded": "🥁 Upgraded wheel — no Sick, boosted rewards!",
  "care.wheel.failed": "⚠️ Training failed",
  "care.wheel.failedFallback": "Training failed",
  "care.wheel.errorLabel": "Error",
  "care.wheel.resultXp": "+{xp} XP Bonus!",
  "care.wheel.resultPrize": "🎉 {xp} XP + Stats Boost!",
  "care.wheel.resultSick": "💊 Your Pet Got Sick!",
  "care.wheel.resultSuika": "💧 +{suika} Suika!",
  "care.wheel.resultNothing": "😐 No Bonus This Time",
  "care.wheel.tapToContinue": "Tap to continue",
  "care.wheel.tierName.bronze": "BRONZE",
  "care.wheel.tierName.silver": "SILVER",
  "care.wheel.tierName.gold": "GOLD",
  "care.wheel.tierName.perfect": "PERFECT",
  "care.wheel.grant": "🥁 {tier} — upgraded wheel{suika, plural, =0 {} other { · # Suika back}}{dailyXp, plural, =0 {} other { · +# daily XP}}",
  "care.wheel.skip": "Straight to the wheel",
  "care.rename.invalid": "Invalid name",
  "care.rename.unavailable": "The name \"{name}\" is not available.",
  "care.rename.failed": "Failed to rename pet",
  "care.rename.success": "Renamed to \"{name}\"",
  "care.rename.title": "Rename pet",
  "care.rename.subtitle": "Change your Suikamon's name",
  "care.rename.action": "Rename",
  "care.rename.description": "Choose a new name. Renaming costs {cost} SUIKA.",
  "care.rename.heading": "Rename your Suikamon",
  "care.rename.placeholder": "New name",
  "care.rename.cost": "{cost} SUIKA",
  "care.rename.costNote": "This will be deducted from your pet's Suika balance.",
  "care.release.failed": "Could not delete this Suikamon",
  "care.release.success": "{petName} has left your team",
  "care.release.title": "Delete Suikamon",
  "care.release.subtitle": "Remove {petName} from your team",
  "care.release.action": "Delete",
  "care.release.dialogTitle": "Delete {petName}?",
  "care.release.dialogText": "{petName} leaves your team for good, with its level, skills and Suika.",
  "care.release.typeToConfirm": "Type <b>{petName}</b> to confirm",
  "care.release.keep": "Keep {petName}",
  "care.release.deleting": "Deleting…",
  "care.card.play": "💖 Play",
  "care.card.view": "View",
  "care.card.revive": "Revive 💧",
  "care.card.eggFound": "🥚 Egg Found!",
  "care.card.level": "Lvl {level}",
  "care.card.canLevelUp": "Can Level Up ⭐",
  "care.card.canEvolve": "Can Evolve 🧬",
  "care.card.needsYou": "Needs You",
  "care.playFirst.titleSpecies": "Play {species} now!",
  "care.playFirst.title": "Play your first Suikamon!",
  "care.playFirst.subtitleSpecies": "Raise your own {species}, battle with it, and watch it evolve. Free to start, no sign-up.",
  "care.playFirst.subtitle": "Raise, battle, and evolve your very own pocket monster. Free to start, no sign-up.",
  "care.playFirst.artSpecies": "{species}, a Suikamon you can play for free",
  "care.playFirst.artEgg": "A Suikamon egg",
  "care.playFirst.eyebrow": "Welcome to Suikamon",
  "care.playFirst.play": "▶ Play free",
  "care.playFirst.later": "Maybe later",
  "care.minigame.fruitCatch.title": "Fruit Catch",
  "care.minigame.fruitCatch.blurb": "Catch falling fruit to make this meal extra nutritious. Good runs add bonus XP and happiness.",
  "care.minigame.fruitCatch.controls": "Drag left/right to move the basket.",
  "care.minigame.snackSort.title": "Snack Sort",
  "care.minigame.snackSort.blurb": "Sort the falling fruit by colour: fresh green fruit into the Bowl, spoiled red fruit into the Bin — before it drops past. Golden treats are worth double.",
  "care.minigame.snackSort.controls": "Drag green fruit to the Bowl, red fruit to the Bin.",
  "care.minigame.fruitSlice.title": "Fruit Slice",
  "care.minigame.fruitSlice.blurb": "Swipe through the fruit Shika tosses up to slice it — but dodge the bombs. Clean slices add bonus XP and happiness.",
  "care.minigame.fruitSlice.controls": "Swipe across the fruit to slice it. Avoid the bombs.",
  "care.minigame.memoryFlip.title": "Memory Flip",
  "care.minigame.memoryFlip.blurb": "Flip the cards two at a time and match every pair of treats before the timer runs out.",
  "care.minigame.memoryFlip.controls": "Tap two cards to flip them and find matching pairs.",
  "care.minigame.bubbleScrub.title": "Bubble Scrub",
  "care.minigame.bubbleScrub.blurb": "Pop every dirt bubble before it fades for a squeaky-clean bonus.",
  "care.minigame.bubbleScrub.controls": "Tap the bubbles to pop them.",
  "care.minigame.mudSwipe.title": "Mud Splat",
  "care.minigame.mudSwipe.blurb": "Tap each mud spot before it dries and hardens.",
  "care.minigame.mudSwipe.controls": "Tap the mud spots to pop them.",
  "care.minigame.sparklePolish.title": "Sparkle Polish",
  "care.minigame.sparklePolish.blurb": "Rub dull spots until they shine. Full polish clears give the best clean bonus.",
  "care.minigame.sparklePolish.controls": "Rub inside each cloudy spot.",
  "care.minigame.pestWhack.title": "Pest Whack",
  "care.minigame.pestWhack.blurb": "Bugs keep popping out of the burrows to bother your Suikamon — bop each one before it ducks back for a squeaky-clean bonus.",
  "care.minigame.pestWhack.controls": "Tap each pest the moment it pops up.",
  "care.minigame.rhythmTraining.title": "Rhythm Training",
  "care.minigame.rhythmTraining.blurb": "Tap on the beat to upgrade the Training Wheel: Sick disappears and rewards grow. Perfect also refunds 1 Suika.",
  "care.minigame.rhythmTraining.controls": "Tap anywhere when the ring hits the target.",
  "care.minigame.reflexBlocks.title": "Reflex Blocks",
  "care.minigame.reflexBlocks.blurb": "Break the lit training block before it fades. Faster streaks earn a stronger wheel.",
  "care.minigame.reflexBlocks.controls": "Tap the glowing block.",
  "care.minigame.balanceBeam.title": "Balance Beam",
  "care.minigame.balanceBeam.blurb": "Keep the marker centered while gusts push your Suikamon off balance.",
  "care.minigame.balanceBeam.controls": "Drag or tap left/right to stay inside the target zone.",
  "care.minigame.blockDrop.title": "Block Drop",
  "care.minigame.blockDrop.blurb": "Slot the falling training blocks together and clear full rows before the clock runs out. Clean stacking strengthens the wheel. Tap the bonus fruit up top for a Double Time window where every point counts double.",
  "care.minigame.blockDrop.controls": "Use the ◀ ↻ ▶ ▼ buttons — or tap to rotate, drag to move, swipe down to drop. Tap the floating fruit for 2× Double Time.",
  "care.minigame.recipeTap.title": "Recipe Tap",
  "care.minigame.recipeTap.blurb": "Follow Shika's quick recipe sequence and tap the right ingredient before the timer drains.",
  "care.minigame.recipeTap.controls": "Tap the highlighted ingredient in order.",
  "care.minigame.result.none": "No bonus this time",
  "care.minigame.result.bronze": "Bronze!",
  "care.minigame.result.silver": "Silver!",
  "care.minigame.result.gold": "Gold!",
  "care.minigame.result.perfect": "PERFECT!",
  "care.minigame.benefit.feed": "Bonus XP and happiness.",
  "care.minigame.benefit.snack": "Bonus happiness.",
  "care.minigame.benefit.train": "Boosts the wheel. Perfect refunds 1 Suika.",
  "care.minigame.benefit.clean": "Bonus clean XP.",
  "care.minigame.starsLabel": "{stars} of {slots} stars",
  "care.minigame.points": "points",
  "care.minigame.continue": "Continue",
  "care.minigame.blockDrop.gemLine": "GEM LINE!",
  "care.minigame.blockDrop.doubleTime": "DOUBLE TIME!",
  "care.minigame.blockDrop.aria": "Block Drop minigame",
  "care.minigame.blockDrop.controlsAria": "Block Drop controls",
  "care.minigame.blockDrop.left": "Move left",
  "care.minigame.blockDrop.rotate": "Rotate",
  "care.minigame.blockDrop.right": "Move right",
  "care.minigame.blockDrop.softDrop": "Soft drop",
  "care.minigame.blockDrop.line": "LINE!",
  "care.refill.failed": "Refill failed",
  "care.refill.success": "💧 +{amount} Suika",
  "care.refill.retry": "Refill failed — please try again.",
  "care.refill.title": "💧 Refill your Suika",
  "care.refill.canRefill": "Suika pays for care, battles and skills for all your Suikamon. Refill free.",
  "care.refill.locked": "Free refills unlock below {threshold} Suika. Win battles to earn more.",
  "care.refill.free": "Free",
  "care.refill.amount": "💧 {amount} Suika",
  "care.refill.refilling": "Refilling…",
  "care.refill.refill": "Refill",
  "care.navigator.goTo": "Go to {name}",
  "care.navigator.noPrevious": "No previous pet",
  "care.navigator.noNext": "No next pet",
  "care.skillsButton.title": "This Suikamon's skills — the four moves it takes into a battle",
  "care.skillsButton.label": "Skills",
  "care.skillsButton.helix": "Your four skills",
  "care.firstBattle.aria": "Your first battle",
  "care.firstBattle.title": "{name} wants to fight!",
  "care.firstBattle.line": "A training battle takes about a minute.",
  "care.firstBattle.go": "Battle",
  "care.firstBattle.later": "Later",
  "care.demo.ready": "🎉 Ready to evolve! Tap the 🧬 button!",
  "care.demo.more": "⭐ {count, plural, one {# more action} other {# more actions}} until Aqua evolves",
  "care.demo.evolved": "🎉 Aqua evolved! Now raise a Suikamon of your own.",
  "care.demo.disabled": "Demo actions are disabled. Refresh the page to try again.",
  "care.demo.adoptTitle": "Adopt Your Suikamon",
  "care.demo.adoptText1": "Pick a free starter, raise it through its forms and take it into battle.",
  "care.demo.adoptText2": "As it levels up it finds eggs, and Rare, Epic and Legendary Suikamon hatch from them.",
  "care.demo.adoptCta": "Adopt a Suikamon",
  "care.statLabel.xp": "XP",
  "care.statLabel.health": "Health",
  "care.statLabel.hunger": "Hunger",
  "care.statLabel.happiness": "Happiness",
  "care.statLabel.energy": "Energy",
  "care.statLabel.discipline": "Discipline",
  "care.statLabel.cleanliness": "Cleanliness",
  "care.history.meals": "Meals",
  "care.history.trainings": "Trainings",
  "care.history.meds": "Meds",
  "care.history.cleans": "Cleans",
  "care.history.battles": "Battles"
}
